export default `

:host {
  --system-ui: 'Source Sans 3', system-ui, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
  'Segoe UI Symbol';

  line-height: 1.5;
  font-weight: 400;

  color: #213547;
  font-size: 16px;
  background-color: #ffffff;
  scrollbar-width: auto;
}

* {
  font-family: var(--system-ui) !important;
  scrollbar-width: auto;
  font-size: 16px;
  font-weight: 400;
  color: #213547;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

footer {
  all: unset;
  position: relative;
  display: block;
}

header {
  all: unset;
  position: fixed;
  display: block;
  height: 73px;

  @media (min-width: $ifxBreakpointXl) {
    height: 83px;
  }
}
`;
